/**
 * @generated SignedSource<<5a1d9f7f409d63b865e48b0b711b4bb6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AskFellowPanelInner_ToolUseAndResult_result$data = {
  readonly contentJson: any | null;
  readonly " $fragmentType": "AskFellowPanelInner_ToolUseAndResult_result";
};
export type AskFellowPanelInner_ToolUseAndResult_result$key = {
  readonly " $data"?: AskFellowPanelInner_ToolUseAndResult_result$data;
  readonly " $fragmentSpreads": FragmentRefs<"AskFellowPanelInner_ToolUseAndResult_result">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AskFellowPanelInner_ToolUseAndResult_result",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentJson",
      "storageKey": null
    }
  ],
  "type": "AskCopilotMessage",
  "abstractKey": null
};

(node as any).hash = "995966e603b4d2afa269d7cbde8b3717";

export default node;
